import $ from 'jquery'
export default {
    name: 'manage-protocole-data',
    components: {},
    props: {
        data_to_add: Object,
        traitant_id: Number,
        data_to_delete: Object
    },

    data() {
        return {
            is_error: false,
            error_message: '',
            save_loading: false,

            description: '',

            del_loading: false,
            is_confirm: false,
        }
    },

    watch: {
        data_to_add() {
            this.description = ''
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        async submitData() {
            const isValid = await this.$refs.pev_form.validate();

            if (!isValid) {
                return;
            }

            const data = {
                data_id: this.data_to_add.data_id,
                data_type: this.data_to_add.data_type,
                user_id: this.traitant_id,
                protocole_id: this.data_to_add.protocole_id,
                hn: this.data_to_add.hn,
                description: this.description
            }
            this.save_loading = true

            this.$store.dispatch('saveProtocoleData', data).then((response) => {
                if (response.success) {
                    this.successToast('Enregistrement effectué avec succès')

                    if (this.data_to_add.data_type == 'plainte') {
                        this.$emit('emitPlaintePatient')
                    } else {
                        this.$emit('emitEvenement')
                    }
                   
                    this.description = ''
                    this.$refs.pev_form.reset()
                    this.$refs.mng_pev.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Supprimer une CAT/Consigne
		 */
        deletePlainte(selector) {
            const confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }


            this.del_loading = true
            
            this.$store.dispatch('deleteProtocoleData', this.data_to_delete).then((response) => {
                if (response.success) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit('emitPlaintePatient')

                    this.$refs.del_plainte.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },
    }
}